export default __webpack_public_path__ + "f01a59f26416d1b2e54db8aea2d9cc10.svg";